import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { group, groupAba } from '@/config/configuration';

@Component
export default class extends Vue {
  get sid() {
    return AppModule.sid;
  }

  get language() {
    return AppModule.language;
  }

  get templateGroup() {
    return group(this.sid);
  }

  get templateAbaGroup() {
    return groupAba(this.sid);
  }

  get template() {
    if (this.templateGroup) {
      return this.sid;
    }
    return 'default';
  }

  get templateAba() {
    if (this.templateAbaGroup) {
      return this.sid;
    }
    return 'default';
  }

  createCookieBanner() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.charset = 'UTF-8';

    // script.src = '//cdn.cookie-script.com/s/de3cfb4aee1fa6b18b95e23390a1aced.js';

    script.src = '//cdn.cookie-script.com/s/ffde3e605d14c9276a0cb63edd865d00.js';
    document.head.appendChild(script);
  }

  jigCreateFontsUrl() {
    const link0: any = document.createElement('link');
    link0.rel = 'preconnect';
    link0.href = 'https://fonts.googleapis.com';
    document.getElementsByTagName('head')[0].appendChild(link0);
    const link1: any = document.createElement('link');
    link1.rel = 'preconnect';
    link1.href = 'https://fonts.gstatic.com';
    link1.crossorigin = 'crossorigin';
    document.getElementsByTagName('head')[0].appendChild(link1);
    const link2: any = document.createElement('link');
    link2.rel = 'stylesheet';
    link2.href = 'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap';
    document.getElementsByTagName('head')[0].appendChild(link2);
  }

  talentpoolCreateFontsUrl() {
    const link0: any = document.createElement('link');
    link0.rel = 'preconnect';
    link0.href = 'https://fonts.googleapis.com';
    document.getElementsByTagName('head')[0].appendChild(link0);
    const link1: any = document.createElement('link');
    link1.rel = 'preconnect';
    link1.href = 'https://fonts.gstatic.com';
    link1.crossorigin = 'crossorigin';
    document.getElementsByTagName('head')[0].appendChild(link1);
    const link2: any = document.createElement('link');
    link2.rel = 'stylesheet';
    link2.href = 'https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap';
    document.getElementsByTagName('head')[0].appendChild(link2);
  }

  abaooeCreateFontsUrl() {
    const link2: any = document.createElement('link');
    link2.rel = 'stylesheet';
    link2.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css';
    document.getElementsByTagName('head')[0].appendChild(link2);
  }

  createIconUrlIco() {
    // Видаляємо існуючі іконки
    const head = document.getElementsByTagName('head')[0];
    const existingIcons = head.querySelectorAll('link[rel="shortcut icon"], link[rel="apple-touch-icon"]');
    existingIcons.forEach((icon) => icon.remove());

    // Додаємо нові іконки
    const link0: any = document.createElement('link');
    link0.rel = 'shortcut icon';
    link0.href = `./favicons/${this.templateAba}/favicon.ico`;
    head.appendChild(link0);
    const link2: any = document.createElement('link');
    link2.type = 'image/png';
    link2.rel = 'apple-touch-icon';
    link2.sizes = '57x57';
    link2.href = `./favicons/${this.templateAba}/app-icon-57x57.png`;
    head.appendChild(link2);
    const link3: any = document.createElement('link');
    link3.type = 'image/png';
    link3.rel = 'apple-touch-icon';
    link3.sizes = '72x72';
    link3.href = `./favicons/${this.templateAba}/app-icon-72x72.png`;
    head.appendChild(link3);
    const link4: any = document.createElement('link');
    link4.type = 'image/png';
    link4.rel = 'apple-touch-icon';
    link4.sizes = '144x144';
    link4.href = `./favicons/${this.templateAba}/app-icon-144x144.png`;
    head.appendChild(link4);
  }

  createIconUrl() {
    const link0: any = document.createElement('link');
    link0.rel = 'shortcut icon';
    link0.href = `./favicons/${this.template}/favicon.gif`;
    document.getElementsByTagName('head')[0].appendChild(link0);
    const link2: any = document.createElement('link');
    link2.type = 'image/png';
    link2.rel = 'apple-touch-icon';
    link2.sizes = '57x57';
    link2.href = `./favicons/${this.template}/app-icon-57x57.png`;
    document.getElementsByTagName('head')[0].appendChild(link2);
    const link3: any = document.createElement('link');
    link3.type = 'image/png';
    link3.rel = 'apple-touch-icon';
    link3.sizes = '72x72';
    link3.href = `./favicons/${this.template}/app-icon-72x72.png`;
    document.getElementsByTagName('head')[0].appendChild(link3);
    const link4: any = document.createElement('link');
    link4.type = 'image/png';
    link4.rel = 'apple-touch-icon';
    link4.sizes = '144x144';
    link4.href = `./favicons/${this.template}/app-icon-144x144.png`;
    document.getElementsByTagName('head')[0].appendChild(link4);
  }

  waitForCookieScriptTemp(): Promise<void> {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        if ((window as any).CookieScript && (window as any).CookieScript.instance) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    });
  }

  waitForCookieScript(timeout = 5000): Promise<void> {
    return new Promise((resolve, reject) => {
      const start = Date.now();

      const interval = setInterval(() => {
        const ready = (window as any).CookieScript?.instance;

        if (ready) {
          clearInterval(interval);
          resolve();
        } else if (Date.now() - start > timeout) {
          clearInterval(interval);
          reject(new Error('CookieScript not loaded within timeout.'));
        }
      }, 100);
    });
  }

  isCookieFunctionality() {
    const instance = (window as any).CookieScript?.instance;
    const dispatch = Array.isArray(instance?.dispatchEventNames)
      ? instance.dispatchEventNames
      : [];

    return (
      dispatch.includes('CookieScriptCategory-functionality')
      || dispatch.includes('CookieScriptCategory-all')
    );
  }

  async setCookieScript() {
    await this.waitForCookieScript();
    AppModule.SetCookieScriptFunctionality(this.isCookieFunctionality());
  }

  async created() {
    document.documentElement.lang = this.language;
    await this.setCookieScript();
    (window as any).reloadComponent = this.setCookieScript;
  }
}
